import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'ProcessLine',
})
export default class ProcessLine extends Vue {
    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: P R O O P S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //
    @Prop({ type: Array }) value!: any;
    @Prop({ type: String }) apmInfo!: any;
    @Prop({ type: String }) type!: string;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    data: string = '';
    isLast: boolean = false;
    lineInfo: any = [];
    approverList: workflow.ApprovalLine[] = [] as workflow.ApprovalLine[];

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch('value')
    onValueChanged() {
        this.setProcessLine();
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getLineClass(status: string) {
        switch (status) {
            case 'A0': return 'proceed last';
            case 'A1': return 'approval';
            case 'A2': return 'proceed';
            case 'A3': return 'proceed last';
            case 'A4': return 'proceed last';
            case 'A5': return 'approval';
            case 'A6': return 'proceed';
            case 'A7': return 'approval';
            case 'A8': return 'proceed last';
            case 'A9': return 'proceed last';
            case 'AC': return 'proceed last';
            case 'AD': return 'proceed last';
            case 'DE': return 'proceed last';
            case 'HD': return 'proceed';
            case 'HE': return 'proceed';
            case 'DR': return 'proceed last'; // 공문 수신대기
            case 'DU': return 'approval'; // 공문 수신
            case 'DL': return 'proceed last'; // 공문 거절
            case 'AA': return 'approval'; // 전결
            case 'AP': return 'approval'; // 기안
            case 'DA': return 'approval'; // 부서협조 접수 (재사용개념)
            case 'D2': return 'proceed'; // 부서협조 진행
        }
        return 'proceed last';
    }

    setProcessLine() {
        if (this.value) {
            this.lineInfo = this.value.filter((v: any) => {
                return v.sortNumber > 0 && v.isDisplay;
            });
            this.approverList = this.lineInfo;
            this.isLast = true;
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
        this.setProcessLine();       
    }
}
